import Vue from "vue";
const view = Vue.extend({ render: h => h("router-view") });

// 单独的链接->教师入职考核课前链接
const assessmentAnswerList = () =>
  import(
    /* webpackChunkName: "assessmentAnswerList" */ "@/views/teacher/assessmentAnswerList/index.vue"
  );
// 单独的链接->教师入职考核课中链接
const assessmentAnswerInClass = () =>
  import(
    /* webpackChunkName: "assessmentAnswerList" */ "@/views/teacher/assessmentAnswerList/indexInClass.vue"
  );
// 单独的链接->教师入职考核课后链接
const assessmentAnswerAfterClass = () =>
  import(
    /* webpackChunkName: "assessmentAnswerList" */ "@/views/teacher/assessmentAnswerList/indexAfterClass.vue"
  );
// 单独的链接->教师入职考核课后链接
const assessmentAnswerShowPage = () =>
  import(
    /* webpackChunkName: "assessmentAnswerList" */ "@/views/teacher/assessmentAnswerList/indexShowPage.vue"
  );
// 单独的链接->教师入职考核课后链接
const assessmentExamScore = () =>
  import(
    /* webpackChunkName: "assessmentAnswerList" */ "@/views/teacher/assessmentAnswerList/indexExamScore.vue"
  );
// 单独的链接->教师入职考核列表页
const assessmentListPage = () =>
  import(
    /* webpackChunkName: "assessmentAnswerList" */ "@/views/teacher/assessmentAnswerList/indexListPage.vue"
  );

export default {
  path: "",
  component: view,
  children: [
    {
      name: "assessmentAnswerList",
      path: "assessmentAnswerList",
      component: assessmentAnswerList
    },
    {
      name: "assessmentAnswerInClass",
      path: "assessmentAnswerInClass",
      component: assessmentAnswerInClass
    },
    {
      name: "assessmentAnswerAfterClass",
      path: "assessmentAnswerAfterClass",
      component: assessmentAnswerAfterClass
    },
    {
      name: "assessmentAnswerShowPage",
      path: "assessmentAnswerShowPage",
      component: assessmentAnswerShowPage
    },
    {
      name: "assessmentExamScore",
      path: "assessmentExamScore",
      component: assessmentExamScore
    },
    {
      name: "assessmentListPage",
      path: "assessmentListPage",
      component: assessmentListPage
    }
  ]
};
